<div class="logout-container">
  <div>You have logged out of video tools.</div>
  <div><a style="cursor: pointer;" (click)="redirectToHomePage()">Click here</a> to login again!</div>
</div>
